<template>
    <form
        class="form-horizontal"
        enctype="multipart/form-data"
        autocomplete="off"
    >
        <div class="row form-group">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.invoice_number') }}</label>
            <div class="col-md-9 col-sm-12">
                <input
                    type="text"
                    class="form-control"
                    v-model="number"
                    :required="true"
                >
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-3 col-sm-12 col-form-label">{{ uLang('app.invoice_date') }}</label>
            <div class="col-md-9 col-sm-12">
                <vue-pikaday
                    v-model="invoice_date"
                    :options="options"
                    :required="true"
                    class="form-control"
                    autocomplete="off"
                />
            </div>
        </div>

        <input
            :disabled="working"
            type="button"
            @click.prevent="commitBookInvoice"
            class="btn btn-brand"
            :value="uLang('app.save')"
        />
    </form>
</template>

<script>
    import { SuccessAlert } from "~/Swals"
    import { PikadayOptions } from "~/Form/elements";

    export default {
        name: 'BuyInvoiceForm',

        props: {
            invoiceId: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                number: '',
                invoice_date: null,
                entity: 'buy_invoice',
                working: false,
                options: PikadayOptions,
            }
        },

        mounted() {
            window.axios.get(route('invoices.buy.edit', { invoice: this.invoiceId }), {
                'invoice_date': this.invoice_date,
                'invoice_number': this.number,
            }).then(({ data: { invoice_date, number_by_coach } }) => {
                this.number = number_by_coach;
                this.invoice_date = new Date(invoice_date);
            })
        },

        methods: {
            async commitBookInvoice() {
                this.working = true;
                const {data} = await window.axios.post(route('invoices.buy.book', { invoice: this.invoiceId }), {
                    'invoice_date': this.invoice_date,
                    'invoice_number': this.number,
                });

                this.$emit('invoiceBooked', data);
                this.$emit('close');
                this.working = false;
                this.number = '';
                this.invoice_date = null;
            },
        },
    }
</script>

<style lang="scss" scoped>
.btn {
    font-size: 11px;
}

.fa-stack {
    font-size: 11px;
}

.fa-backward::before {
    margin-left: -5px;
}
</style>
